import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeLocalStorage } from './utils/initializeLocalStorage';
import { processHashBeforeRouter } from './utils/CompatibleRouter';
import { installSegmentStorageBridge } from './utils/segmentStorageBridge';

const container = document.getElementById('root');

initializeLocalStorage();
installSegmentStorageBridge();
processHashBeforeRouter();

if (container) {
  const root = ReactDOM.createRoot(container);

  root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
  );
}